<script setup>
const props = defineProps({
  error: {
    type: Object,
    default: () => ({}),
  },
})

const errorDetails = computed(() => ({
  statusCode: props.error?.statusCode,
  statusMessage: props.error?.statusMessage,
  message: props.error?.message,
  stack: props.error?.stack,
  description: props.error?.description,
  data: props.error?.data,
}))

usePageSeo({
  title: '404 - Page Not Found | NicSRS',
  description: 'The page you are looking for could not be found.',
  bodyId: 'error-page',
})
</script>

<template>
  <div class="animation-container">
    <h1 class="heading">{{ error.statusCode === 404 ? '404' : 'Error' }}</h1>
    <pre style="color:red;text-align:left;max-width:800px;margin:0 auto;white-space:pre-wrap;word-break:break-all;">{{ JSON.stringify(errorDetails, null, 2) }}</pre>
    <div class="wrapper">
      <svg viewBox="0 0 120 120" style="overflow: visible">
        <defs>
          <path id="a" d="M0 4.21585531V.05647427h4.15889198v4.15938104H0z" />
        </defs>
        <g fill="none" fill-rule="evenodd">
          <g class="stars animated">
            <path
              d="M32.9862439 29.2981615c.1110863.8208744-.4626987 1.5770446-1.2847376 1.6881041-.8210729.1110595-1.5764599-.4635526-1.6875462-1.2844271-.1120523-.8208744.4626987-1.5760789 1.2837716-1.6881041.8220388-.1110595 1.5774259.4635526 1.6885122 1.2844271"
              fill="#D0E7FB"
            />
          </g>
          <g class="rocket animated">
            <path fill="#F2F9FE" d="M53.9118329 92L44 81.3510365 50.0881671 76 60 86.6489635z" />
          </g>
        </g>
      </svg>
    </div>
    <p style="text-align:center;margin-top:20px">
      <NuxtLink to="/">Back to Home</NuxtLink>
    </p>
  </div>
</template>
